<template>
  <v-dialog v-model="dialogShow" persistent width="90%" height="90%" max-width="1180" max-height="870">
    <v-card>
      <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-weight:bold;">
        封面编辑
        <v-spacer></v-spacer>
        <p @click="hideDialog" style="float:right;font-size:14px;color:#A6A6A6;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>

        <v-stepper v-model="currStep" height="32" elevation="0" style="position: absolute;left: 50%;transform: translate(-50%);width:500px;font-size:16px;">
          <v-stepper-header style="height:32px;">
            <v-stepper-step step="1" :complete="currStep > 1" style="height:32px;padding:0 24px;">
              上传图片
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="currStep > 2" style="height:32px;padding:0 24px;">
              图片裁剪
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" style="height:32px;padding:0 24px;">
              添加封面文字
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-card-title>
      <v-card-text class="pa-0">
        <div style="position:relative;height:600px;border-top:1px solid transparent;">
          <!--第一步 上传图片-->
          <div v-if="currStep === 1" style="width:300px;margin:180px auto 0 auto;">
            <div style="display:flex;flex-direction: column;align-items: center;">
              <div style="position:relative;width:200px;height:150px;margin:0 auto;">
                <div style="width:100%;height:100%;border:1px dashed #a6a6a6;border-radius:2px;">
                  <p style="font-size:30px;text-align:center;line-height:150px;color:#1976D2;" class="iconfontFamily">&#xe60b;</p>
                </div>
                <input ref="uploadImageInput" @change="uploadImage()" type="file" accept="image/jpeg,image/jpg,image/png" style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
              </div>
              <p style="font-size:16px;color:#000000;" class="mt-1">拖入或点击上传封面</p>
              <p style="font-size:12px;color:#a6a6a6;" class="mt-3">支持：jpg、jpeg、png，单张图片大小5M以内</p>
            </div>
          </div>

          <!--第二步 图片裁剪-->
          <div v-if="currStep === 2">
            <div style="width:700px;height:500px;background:#e5e5e5;margin:16px auto 0 auto;border-radius:2px;">
              <vueCropper
                  id="editCoverCropper"
                  ref="editCoverCropper"
                  :img="uploadImageSrc"
                  :outputType="options.outputType"
                  :auto-crop="options.autoCrop"
                  :auto-crop-width="options.autoCropWidth"
                  :auto-crop-height="options.autoCropHeight"
                  :fixed="true"
                  :centerBox="true"
              ></vueCropper>


            </div>
            <!--底栏-->
            <div style="position:absolute;bottom:0;width:100%;height:60px;border-top:1px solid #e5e5e5;display:flex;align-items: center;" class="px-6">
              <v-spacer></v-spacer>
              <v-btn @click="backUploadStep" height="30" color="#f5f5f5" style="margin-top:2px;margin-right:16px;">上一步</v-btn>
              <v-btn @click="cropperOK" height="30" dark color="#1E3A8A" style="margin-top:2px;">下一步</v-btn>
            </div>
          </div>

          <!--第三步-->
          <div v-if="currStep === 3" style="width:100%;height:100%;display:flex;">
            <div style="position:relative;width:250px;height:100%;border-right:1px solid #e5e5e5;">
              <v-expansion-panels v-model="addTextPanel" accordion flat class="mt-3">
                <v-expansion-panel>
                  <v-expansion-panel-header style="color:#1976d2">
                    热点封面
                    <template v-slot:actions>
                      <v-icon color="#1976d2">mdi-menu-down</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="(item,index) in addTextHotList" :key="index">
                      <div style="display:flex;align-items: center" class="mb-3 mt-1">
                        <v-divider></v-divider>
                        <p style="color:#a6a6a6;" class="mx-1">{{item.type}}</p>
                        <v-divider></v-divider>
                      </div>
                      <div style="overflow:hidden;">
                        <p @click="chooseHot(textItem)" v-for="(textItem,textIndex) in item.textList" :key="'text'+textIndex"
                           :style="{'margin-right':textIndex%3 === 2 ? '0' : '15px','color':addTextMyHot !== textItem ? '#000000' : '#1976d2'}" style="cursor:pointer;float:left;" class="mb-3">
                          {{textItem}}
                        </p>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header style="color:#1976d2">
                    自定义
                    <template v-slot:actions>
                      <v-icon color="#1976d2">mdi-menu-down</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div style="overflow:hidden;">
                      <div @click="chooseTextNum(item)" v-for="(item,index) in addTextNumExampleList" :key="'textNum'+index"
                           :style="{'margin-right':index%2 === 1 ? '0' : '10px','background':addTextMyNum !== item.type ? 'transparent' : '#C6DCF5','border-color':addTextMyNum !== item.type ? '#e5e5e5' : '#1976D2'}"
                           style="width:95px;height:120px;border:1px solid #e5e5e5;margin-bottom:10px;float:left;cursor:pointer;
                         display:flex;flex-direction: column;align-items: center;justify-content: center;">
                        <v-avatar color="transparent" size="70">
                          <v-img :src="item.exampleSrc"></v-img>
                        </v-avatar>
                        <p class="mt-1">{{item.textNum}}</p>
                      </div>
                    </div>
                    <p v-if="addTextMyNum === ''" style="color:#a6a6a6;" class="mt-1">请选择封面字数样式</p>
                    <v-text-field v-if="addTextMyNum !== ''" v-model="addTextMyText" dense outlined placeholder="请输入封面文字内容" solo :counter="addTextMyNum.slice(0,1)"
                                  background-color="#ffffff" color="#808080" style="font-size:14px;" class="mt-1"></v-text-field>

                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <div v-if="addTextMyHot !== '' || addTextMyNum !== '' || addTextMyText !== ''" style="position:absolute;bottom:15px;width:100%;">
                <v-btn @click="clearAddTextMy" large color="#f5f5f5" style="width:180px;margin:0 auto;display:block;">
                  <span>重置</span>
                </v-btn>
              </div>
            </div>
            <div style="flex:1;display:flex;flex-direction:column;align-items: center;">
              <div ref="addTextCover" :style="{'background-image':'url('+cropperImageBase64+')'}" class="addTextImageArea">

                <!--文字样式-->
                <!--3字-->
                <p v-if="addTextMyNum === '3'" :style="{'color':addTextMyText!==''?'#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:440px;font-size:150px;" class="coverTextShadow">
                  {{addTextMyText!=='' ? addTextMyText : '请输入'}}
                </p>
                <!--4字 热门封面-->
                <div v-if="addTextMyNum === '4' || addTextMyHot !== ''">
                  <p :style="{'color':(addTextMyNum === '4'&&addTextMyText!=='')||addTextMyHot !== '' ? '#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:135px;font-size:160px;margin-top:85px;" class="coverTextShadow">
                    {{addTextMyNum === '4' ? (addTextMyText!=='' ? addTextMyText.slice(0,2) : '输入') : addTextMyHot.slice(0,2)}}
                  </p>
                  <p :style="{'color':(addTextMyNum === '4'&&addTextMyText!=='')||addTextMyHot !== '' ? '#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:135px;font-size:160px;" class="coverTextShadow">
                    {{addTextMyNum === '4' ? (addTextMyText!=='' ? addTextMyText.slice(2,4) : '文字') : addTextMyHot.slice(2,4)}}
                  </p>
                </div>
                <!--5字 上2下3-->
                <div v-if="addTextMyNum === '5_1'">
                  <p :style="{'color':addTextMyText!==''?'#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:115px;font-size:135px;margin-top:105px;" class="coverTextShadow">
                    {{addTextMyText!=='' ? addTextMyText.slice(0,2) : '请输'}}
                  </p>
                  <p :style="{'color':addTextMyText!==''?'#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:115px;font-size:135px;" class="coverTextShadow">
                    {{addTextMyText!=='' ? addTextMyText.slice(2,5) : '入文字'}}
                  </p>
                </div>
                <!--5字 上3下2-->
                <div v-if="addTextMyNum === '5_2'">
                  <p :style="{'color':addTextMyText!==''?'#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:115px;font-size:135px;margin-top:105px;" class="coverTextShadow">
                    {{addTextMyText!=='' ? addTextMyText.slice(0,3) : '请输入'}}
                  </p>
                  <p :style="{'color':addTextMyText!==''?'#ffffff':'rgba(255, 255, 255, 0.5)'}" style="line-height:115px;font-size:135px;" class="coverTextShadow">
                    {{addTextMyText!=='' ? addTextMyText.slice(3,5) : '文字'}}
                  </p>
                </div>



              </div>
              <v-spacer></v-spacer>
              <div style="width:100%;height:60px;display:flex;align-items: center;" class="px-6">
                <v-spacer></v-spacer>
                <v-btn @click="backCropperStep" height="30" color="#f5f5f5" style="margin-top:2px;margin-right:16px;">上一步</v-btn>
                <v-btn @click="addTextOK" height="30" dark :color="addTextMyNum!=='' && (addTextMyText.length != addTextMyNum.slice(0,1)) ? '#8F9DC5' :'#1E3A8A'" style="margin-top:2px;">确定</v-btn>
              </div>
            </div>





          </div>


        </div>


      </v-card-text>
    </v-card>



  </v-dialog>
</template>

<script>
import { VueCropper }  from 'vue-cropper'
import html2canvas from "html2canvas";
import addTextNum3 from '/src/assets/edit_create_cover_dialog/addTextNum3.png'
import addTextNum4 from '/src/assets/edit_create_cover_dialog/addTextNum4.png'
import addTextNum5_1 from '/src/assets/edit_create_cover_dialog/addTextNum5_1.png'
import addTextNum5_2 from '/src/assets/edit_create_cover_dialog/addTextNum5_2.png'
export default {
  name: "EditCreateCoverDialog",
  components: {
    VueCropper
  },
  props:["dialogShow"],
  data(){
    return{

      currStep:1,

      //上传图片
      uploadImageSrc:"",

      //裁剪图片
      options: {
        outputType: 'png',  // 需要剪裁的图片
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 250, // 默认生成截图框的宽度
        autoCropHeight: 250, // 默认生成截图框的长度
      },
      cropperImageBase64:"",

      //添加文字 左侧扩展面板默认打开 热点文字
      addTextPanel:0,
      //添加文字 热点文字
      addTextHotList:[
        {
          type:"热点封面",
          textList:["时政新闻","卫星目击","娱乐资讯","大国工程"]
        },
        {
          type:"自然风景",
          textList:["风景名胜","世界名山","水域风光","生物景观","地貌景观"]
        },
        {
          type:"知识科普",
          textList:["人文历史","地域风情","地球解码","星空探秘"]
        }

      ],
      //添加文字 自定义字数
      addTextNumExampleList:[
        {
          exampleSrc:addTextNum3,
          textNum:"3",
          type:"3"
        },
        {
          exampleSrc:addTextNum4,
          textNum:"4",
          type:"4"
        },
        {
          exampleSrc:addTextNum5_1,
          textNum:"5",
          type:"5_1"
        },
        {
          exampleSrc:addTextNum5_2,
          textNum:"5",
          type:"5_2"
        }

      ],
      //选择的信息
      addTextMyHot:"",
      addTextMyNum:"",
      addTextMyText:"",

      //最终封面
      finalImageSrc:"",



    }


  },
  methods:{
    //上传图片
    uploadImage(){
      let file = this.$refs.uploadImageInput.files[0];

      if(file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/jpg"){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件必须为以下格式：jpg、jpeg、png"
        this.$store.state.snackbarType = 'error'

        this.$refs.uploadImageInput.value = '';
      }
      else if(file.size > 1024 * 1024 * 5){
        this.$store.state.snackbarShow=true
        this.$store.state.snackbarText = "文件大小不能超过5M"
        this.$store.state.snackbarType = 'error'

        this.$refs.uploadImageInput.value = '';
      }
      else{
        //合法
        let paramData = new FormData();
        paramData.append('multipartFile',file);
        this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
            .then((resultData)=>{
              resultData = resultData.data;
              if(resultData.status === 200){
                // this.uploadImageSrc = resultData.data.picture;   //跨域
                this.uploadImageSrc = resultData.data.picture.replace("https://cgwxforum.obs.cn-north-4.myhuaweicloud.com:443/","/huaweicloud");
                this.currStep = 2;
                this.$refs.uploadImageInput.value = '';

              }else{
                console.log(resultData.status + resultData.message);
                this.$refs.uploadImageInput.value = '';
              }
            })
            .catch(()=>{
              this.$refs.uploadImageInput.value = '';
            })
      }


    },
    //返回第一步
    backUploadStep(){
      this.currStep = 1;
    },

    //确定裁剪
    cropperOK(){
      this.$refs.editCoverCropper.getCropData(data => {
        //data是图片的base64编码
        this.cropperImageBase64 = data;
        this.currStep = 3;
      })
    },
    //返回裁剪步骤
    backCropperStep(){
      this.currStep = 2;
      this.addTextMyHot = "";
      this.addTextMyNum = "";
      this.addTextMyText = "";
    },


    //选择热点封面
    chooseHot(item){
      this.addTextMyHot = item;
      this.addTextMyNum = "";
      this.addTextMyText = "";
    },
    //选择自定义字数
    chooseTextNum(item){
      this.addTextMyHot = "";
      this.addTextMyNum = item.type;
      this.addTextMyText = "";
    },
    //清空用户的选择情况
    clearAddTextMy(){
      this.addTextMyHot = "";
      this.addTextMyNum = "";
      this.addTextMyText = "";
    },



    //确定添加文字，生成最终封面
    addTextOK(){
      if(this.addTextMyNum!=='' && (this.addTextMyText.length != this.addTextMyNum.slice(0,1))){
        //不合法
      }
      else{
        //合法
        // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
        html2canvas(this.$refs.addTextCover, {
          // width: 30, //截图宽度
          // height: 50, //截图高度
          backgroundColor: null, //画出来的图片有白色的边框,不要可设置背景为透明色（null）
          useCORS: true, //支持图片跨域
          scale: 1, //设置放大的倍数
        }).then((canvas) => {
          // 把生成的base64位图片上传到服务器,生成在线图片地址
          let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64

          //上传后台
          let file = this.$utils.base64ToFile(url,"创作封面.jpg");
          let paramData = new FormData();
          paramData.append('multipartFile',file);
          this.$axios.post('/managerApi/upoladFile/uploadPiture',paramData)
              .then((resultData)=>{
                resultData = resultData.data;
                if(resultData.status === 200){
                  this.finalImageSrc = resultData.data.thumb;
                  this.$emit("editCoverOK",this.finalImageSrc)
                  this.hideDialog();
                }else{
                  console.log(resultData.status + resultData.message);
                }
              })
              .catch(()=>{

              })

        });
      }

    },

    //隐藏弹窗
    hideDialog(){
      this.$emit("hideCreateCoverDialog")
    }



  }
}
</script>


<style scoped>

.addTextImageArea{
  width:440px;
  height:440px;
  /*border:1px solid #e5e5e5;*/
  background-repeat: no-repeat !important;
  background-position:center !important;
  background-size:100% 100% !important;
  margin-top:60px;
  font-size:70px;
  color:#ffffff;
  text-align:center;
  font-family: "createCoverText";
}
/*封面文字字体*/
@font-face {
  font-family: "createCoverText";
  src: url('../../fonts/createCoverText.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.coverTextShadow{
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
}


</style>

<style>
/*裁剪区域样式*/
#editCoverCropper.vue-cropper{
  background:#eeeeee;
  background-image:none !important;
}
#editCoverCropper .cropper-drag-box {
  background:rgba(220,220,220,0.5);
}

/*提示栏样式*/
 .editCoverDialog_bottomSnackbar .v-snack__wrapper{
   min-height:0;
   max-width:100%;
   margin:0;
   position:absolute;
   top:58px;
   left:0;
 }
.editCoverDialog_bottomSnackbar .v-snack__content{
  padding:0;
  text-align:center;
}

</style>
